import { render, staticRenderFns } from "./minicard.vue?vue&type=template&id=2cd1a92a"
import script from "./minicard.vue?vue&type=script&lang=js"
export * from "./minicard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports